import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx } from "react/jsx-runtime";
import { RoundQuantityPicker } from "@faire/retailer-visitor-shared/components/RoundQuantityPicker";
import { getSettingOptimizedAddToCartDebounce } from "@faire/retailer-visitor-shared/settings/getSettingOptimizedAddToCartDebounce";
import React, { useCallback } from "react";
export var ProductTileRoundQuantityOptionPicker = function(props) {
    var _React_useState = _sliced_to_array(React.useState(props.value), 2), value = _React_useState[0], setValue = _React_useState[1];
    var prevPropValue = React.useRef(props.value);
    // As we speed up the ATC action, there is a higher chance that an action has started before the previous action completed.
    // the pendingUpdatesQueue tracks the updates intiated on the FE that have not resolved yet. The update will be resolved when
    // FE receives an updated quantity from a BE response (ie props.value changes).
    var pendingUpdatesQueue = React.useRef([]);
    var validateValueAgainstPendingUpdatesQueue = useCallback(function(newValue) {
        // mulitple ATC clicks can be batched when hitting the BE and receiving a response, so we will look for the first occurence of the updated quantity
        var firstOccurenceIndex = pendingUpdatesQueue.current.findIndex(function(pendingValue) {
            return pendingValue === newValue;
        });
        // if the updated quantity is not pending, the action was initiated from somewhere else, like the brand sidecart.
        if (firstOccurenceIndex === -1) {
            setValue(newValue);
            pendingUpdatesQueue.current = [];
        } else {
            pendingUpdatesQueue.current = pendingUpdatesQueue.current.slice(firstOccurenceIndex);
        }
    }, []);
    if (props.value !== prevPropValue.current) {
        if (getSettingOptimizedAddToCartDebounce()) {
            validateValueAgainstPendingUpdatesQueue(props.value);
        } else {
            setValue(props.value);
        }
        prevPropValue.current = props.value;
    }
    var onValueChange = function(newValue) {
        setValue(newValue);
        if (getSettingOptimizedAddToCartDebounce()) {
            pendingUpdatesQueue.current.push(newValue);
        }
        if (props.maxValue && props.maxValue !== 0 && newValue <= props.maxValue || props.maxValue === undefined) {
            props.onChange(newValue);
        }
    };
    return /*#__PURE__*/ _jsx(RoundQuantityPicker, _object_spread_props(_object_spread({}, props), {
        value: props.isMultiOption ? props.value : value,
        onChange: onValueChange
    }));
};
